import { LinearProgress, Typography } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import styled from 'styled-components';
import { useMemo } from 'react';

const ProgressBar = styled(LinearProgress)`
  &.MuiLinearProgress-root {
    background-color: ${ColorDynamic.Silver400};
  }
  &.MuiLinearProgress-bar1Determinate {
    background-color: ${ColorDynamic.Blue300};
  }
`;

interface VehicleSubhaulProgressProps {
  shipmentCount: number;
  currentShipmentIndex: number;
}

export function VehicleSubhaulProgress({
  shipmentCount,
  currentShipmentIndex,
}: VehicleSubhaulProgressProps) {
  const isMultipleLoads = shipmentCount > 1;

  const progressValue = useMemo(() => {
    if (shipmentCount === 0) return 0;
    return isMultipleLoads
      ? ((currentShipmentIndex + 1) / shipmentCount) * 100
      : 100;
  }, [shipmentCount, isMultipleLoads, currentShipmentIndex]);

  return (
    <Box paddingTop={isMultipleLoads ? 'xsmall' : 'none'}>
      <Stack space="medium">
        {isMultipleLoads ? (
          <Stack space="xsmall">
            <Box paddingLeft="large">
              <Typography color="textPrimary" variant="body1">
                {currentShipmentIndex + 1} of {shipmentCount} loads
              </Typography>
            </Box>
            <ProgressBar variant="determinate" value={progressValue} />
          </Stack>
        ) : null}
      </Stack>
    </Box>
  );
}
